import { render, staticRenderFns } from "./mustReadDetail.vue?vue&type=template&id=65353fa4&scoped=true"
import script from "./mustReadDetail.vue?vue&type=script&lang=ts"
export * from "./mustReadDetail.vue?vue&type=script&lang=ts"
import style0 from "./mustReadDetail.vue?vue&type=style&index=0&id=65353fa4&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65353fa4",
  null
  
)

export default component.exports